import { FC, useState } from 'react';

import multicreationBidsBudgetsDeleteButtonClick from '@hh.ru/analytics-js-events/build/clickme/employer/auction/multicreation/multicreation_bids_budgets_delete_button_click';
import {
    HSpacingContainer,
    TableBody,
    TableCell,
    TableRow,
    useBreakpoint,
    VSpacingContainer,
} from '@hh.ru/magritte-ui';

import { AuctionDateEnd } from 'components/MultiCreationAuction/BidsAndBudgetsTable/BidsAndBudgetsTableBody/components/AuctionDateEnd';
import { AuctionDateStart } from 'components/MultiCreationAuction/BidsAndBudgetsTable/BidsAndBudgetsTableBody/components/AuctionDateStart';
import { BidInput } from 'components/MultiCreationAuction/BidsAndBudgetsTable/BidsAndBudgetsTableBody/components/BidInput/BidInput';
import { BudgetInput } from 'components/MultiCreationAuction/BidsAndBudgetsTable/BidsAndBudgetsTableBody/components/BudgetInput/BudgetInput';
import { VacancyInfo } from 'components/MultiCreationAuction/BidsAndBudgetsTable/BidsAndBudgetsTableBody/VacancyInfo/VacancyInfo';
import { DeleteButton } from 'components/MultiCreationAuction/BidsAndBudgetsTable/DeleteButton/DeleteButton';

import {
    deleteMultiCreationVacanciesAuctionInfoItemById,
    selectMultiCreationVacanciesAuctionInfo,
    setMultiCreationSelectedVacancyIds,
} from 'store/models/multiCreation';
import { useDispatch, useSelector } from 'store/utils';

import styles from 'components/MultiCreationAuction/BidsAndBudgetsTable/BidsAndBudgetsTable.module.less';

export const BidsAndBudgetsTableBody: FC<{ paddingLeft: number; paddingRight: number }> = ({
    paddingLeft,
    paddingRight,
}) => {
    const selectedVacancyIds = useSelector(({ multiCreation }) => multiCreation.selectedVacancyIds);
    const vacanciesAuctionInfo = useSelector(selectMultiCreationVacanciesAuctionInfo);

    const [showActionVacancyId, setShowActionVacancyId] = useState<number | null>(null);

    const { isMobile } = useBreakpoint();
    const dispatch = useDispatch();

    const handleDeleteClick = (vacancyId: number) => {
        multicreationBidsBudgetsDeleteButtonClick({ vacancyId });

        const newSelectedVacanciesIds = { ...selectedVacancyIds };
        delete newSelectedVacanciesIds[vacancyId];

        dispatch([
            deleteMultiCreationVacanciesAuctionInfoItemById(vacancyId),
            setMultiCreationSelectedVacancyIds(newSelectedVacanciesIds),
        ]);
    };

    return !isMobile ? (
        <TableBody>
            {Object.keys(vacanciesAuctionInfo).map((key) => {
                const vacancyId = Number(key);
                return (
                    <TableRow
                        key={key}
                        action={
                            Object.keys(vacanciesAuctionInfo).length > 1 ? (
                                <DeleteButton
                                    dataQa={`delete-button-${vacancyId}`}
                                    onDelete={() => handleDeleteClick(vacancyId)}
                                />
                            ) : undefined
                        }
                        onMouseEnter={() => {
                            setShowActionVacancyId(vacancyId);
                        }}
                        onMouseLeave={() => {
                            setShowActionVacancyId(null);
                        }}
                        showAction={showActionVacancyId === vacancyId}
                        data-qa={`vacancies-auction-info-row-${vacancyId}`}
                    >
                        <TableCell m={12}>
                            <div
                                className={styles.rowWrapper}
                                data-qa={`vacancies-auction-info-row-wrapper-${vacancyId}`}
                            >
                                <div className={styles.nameColumn}>
                                    <VacancyInfo vacancyId={vacancyId} />
                                </div>
                                <div className={styles.bidColumn}>
                                    <BidInput vacancyId={vacancyId} />
                                </div>
                                <div className={styles.budgetColumn}>
                                    <BudgetInput vacancyId={vacancyId} />
                                </div>
                                <div className={styles.startAtColumn}>
                                    <AuctionDateStart vacancyId={vacancyId} />
                                </div>
                                <div className={styles.endAtColumn}>
                                    <AuctionDateEnd vacancyId={vacancyId} />
                                </div>
                            </div>
                        </TableCell>
                    </TableRow>
                );
            })}
        </TableBody>
    ) : (
        <>
            {Object.keys(vacanciesAuctionInfo).map((key) => {
                const vacancyId = Number(key);
                return (
                    <div key={vacancyId} className={styles.mobileRow} style={{ paddingLeft, paddingRight }}>
                        <VSpacingContainer default={24}>
                            <VacancyInfo
                                vacancyId={vacancyId}
                                deleteButton={
                                    Object.keys(vacanciesAuctionInfo).length > 1 ? (
                                        <DeleteButton
                                            dataQa={`delete-button-${vacancyId}`}
                                            onDelete={() => handleDeleteClick(vacancyId)}
                                        />
                                    ) : undefined
                                }
                            />
                            <HSpacingContainer default={16}>
                                <BidInput vacancyId={vacancyId} />
                                <BudgetInput vacancyId={vacancyId} />
                            </HSpacingContainer>
                            <HSpacingContainer default={16}>
                                <AuctionDateStart vacancyId={vacancyId} />
                                <AuctionDateEnd vacancyId={vacancyId} />
                            </HSpacingContainer>
                        </VSpacingContainer>
                    </div>
                );
            })}
        </>
    );
};
